<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{'main.nav.links.help.shortLabel' | translate}}
                <app-tooltip [text]="'main.nav.links.help.summary' | translate"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-tab-group color="accent" animationDuration="0ms">
            <mat-tab [label]="'help.technicalSupport.shortLabel' | translate">
                <section class="tab-content">
                    <app-contact></app-contact>
                </section>
                <section class="tab-content">
                    <app-supported-browsers></app-supported-browsers>
                </section>
            </mat-tab>
            <mat-tab *ngIf="hasTutorial" [label]="'help.tutorial.title.shortLabel' | translate">
                <section class="tab-content">
                    <app-tutorial></app-tutorial>
                </section>
            </mat-tab>
            <mat-tab *ngIf="isAuth" [label]="'help.wiki.title.shortLabel'|translate">
                <section class="tab-content">
                    <app-wiki-tab></app-wiki-tab>
                </section>
            </mat-tab>
            <mat-tab [label]="'help.bizzmine.title.fullLabel'|translate">
                <section class="tab-content">
                    <app-bizzmine-tab></app-bizzmine-tab>
                </section>
            </mat-tab>
            <mat-tab *ngIf="hasMonitoring" [label]="'main.nav.links.monitoring.shortLabel' | translate">
                <section class="tab-content">
                    <app-monitoring></app-monitoring>
                </section>
            </mat-tab>
            <mat-tab *ngIf="isAuth" [label]="'help.changelog.title.shortLabel' | translate">
                <section class="tab-content">
                    <app-changelog showAll="true"></app-changelog>
                </section>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>
</mat-card>
